import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Column } from "@ant-design/plots";

const DemoColumn = () => {
  const data = [
    {
      month: "Jan",
      gender: "Male",
      value: 1350,
    },
    {
      month: "Jan",
      gender: "Female",
      value: 850,
    },
    {
      month: "Jan",
      gender: "Children",
      value: 1150,
    },

    {
      month: "Feb",
      gender: "Male",
      value: 1450,
    },
    {
      month: "Feb",
      gender: "Female",
      value: 950,
    },
    {
      month: "Feb",
      gender: "Children",
      value: 80,
    },

    {
      month: "Mar",
      gender: "Male",
      value: 1150,
    },
    {
      month: "Mar",
      gender: "Female",
      value: 850,
    },
    {
      month: "Mar",
      gender: "Children",
      value: 950,
    },

    {
      month: "Apr",
      gender: "Male",
      value: 1450,
    },
    {
      month: "Apr",
      gender: "Female",
      value: 850,
    },
    {
      month: "Apr",
      gender: "Children",
      value: 1050,
    },

    {
      month: "May",
      gender: "Male",
      value: 1450,
    },
    {
      month: "May",
      gender: "Female",
      value: 850,
    },
    {
      month: "May",
      gender: "Children",
      value: 250,
    },

    {
      month: "Jun",
      gender: "Male",
      value: 1450,
    },
    {
      month: "Jun",
      gender: "Female",
      value: 20,
    },
    {
      month: "Jun",
      gender: "Children",
      value: 1050,
    },

    {
      month: "Jul",
      gender: "Male",
      value: 1450,
    },
    {
      month: "Jul",
      gender: "Female",
      value: 850,
    },
    {
      month: "Jul",
      gender: "Children",
      value: 50,
    },

    {
      month: "Aug",
      gender: "Male",
      value: 250,
    },
    {
      month: "Aug",
      gender: "Female",
      value: 1050,
    },
    {
      month: "Aug",
      gender: "Children",
      value: 150,
    },

    {
      month: "Sep",
      gender: "Male",
      value: 1450,
    },
    {
      month: "Sep",
      gender: "Female",
      value: 50,
    },
    {
      month: "Sep",
      gender: "Children",
      value: 1050,
    },

    {
      month: "Oct",
      gender: "Male",
      value: 1250,
    },
    {
      month: "Oct",
      gender: "Female",
      value: 850,
    },
    {
      month: "Oct",
      gender: "Children",
      value: 1050,
    },

    {
      month: "Nov",
      gender: "Male",
      value: 1120,
    },
    {
      month: "Nov",
      gender: "Female",
      value: 850,
    },
    {
      month: "Nov",
      gender: "Children",
      value: 1050,
    },

    {
      month: "Dec",
      gender: "Male",
      value: 1450,
    },
    {
      month: "Dec",
      gender: "Female",
      value: 650,
    },
    {
      month: "Dec",
      gender: "Children",
      value: 1120,
    },
  ];

  const config = {
    data,
    xField: "month",
    yField: "value",
    seriesField: "gender",
    isGroup: true,
    isStack: true,
    animation: false,

    legend: {
    //   item:{
    //     style:{borderRadius:"50%", 
    //   //   // backgroundColor:"red"
    // },
    //   },
      // MarkerSymbolCallback:{circle},
      position: "bottom",
      itemFormatter(val) {
        return val + " %";
      },
      marker: {
        symbol: 'circle', // shape of the marker
        // radius: 5, // radius of the circle
      },
    },

    columnStyle: {
      radius: [0, 0, 0, 0],
    },

    color: ({ gender }) => {
      if (gender === "Male") {
        return "#165DFF";
      }
      if (gender === "Female") {
        return "#0FC6C2";
      }
      if (gender === "Children") {
        return "#FADC19";
      }
    },
  
  };

  return <Column {...config} />;
};

export default DemoColumn;
